import { commitmentsRoutes } from "src/routing/domains/developments/commitments/commitments";
import { developmentDetailMigratedRoute } from "src/routing/domains/developments/detail/developmentDetail";
import { costMappingRoutes } from "src/routing/domains/developments/full-page/fullPage";
import { developmentsListRoute } from "src/routing/domains/developments/list/developmentsList";

/**
 * Migrated development route trees registered in `Router.tsx`.
 *
 * Role: data router domain aggregate.
 *
 * Large domain: `domains/developments/` with per-subtree folders (`*Paths.ts`, leaf routes, smoke tests)
 * aggregated here — see `src/routing/README.md`.
 *
 * Unlike libraries (sibling top-level prefixes each with their own `AppShell`), development detail
 * shares one `/developments/:developmentId` parent (`developmentDetailMigratedRoute`) so context +
 * SideNav stay mounted across section navigations. List, cost-mapping, and commitments are sibling
 * top-level trees.
 */
export const developmentsRoutes = [
  developmentsListRoute,
  developmentDetailMigratedRoute,
  ...costMappingRoutes,
  ...commitmentsRoutes,
];

export { developmentDetailRoutes } from "src/routing/domains/developments/detail/developmentDetail";
